 // -----------------  Слайдера --------------------

 const Sliders = {
   MAIN_SLIDER: {
     ELEMENT: $(".main-slider"),
     SETTINGS: {
       accessibility: true,
       arrows: true,
       dots: true,
       speed: 1000,
       slidesToShow: 1,
       prevArrow: $(".main-slide__l"),
       nextArrow: $(".main-slide__r"),
       dotsClass: 'main-slider__dots',
       responsive: [{
           breakpoint: 992,
           settings: {
             dots: false,
           }
         },

       ]
     },
     // BREAKPOINT: 1600,
     // CLASSNAME: '',
   },
   GALERY_SLIDER: {
     ELEMENT: $(".third-slider"),
     SETTINGS: {
       accessibility: true,
       arrows: true,
       dots: false,
       autoplay: true,
       speed: 1500,
       // variableWidth: true,
       slidesToShow: 3,
       centerMode: true,
       infinite: true,
       centerPadding: '200px',
       // autoplay: true,
       // autoplaySpeed: 6000,
       prevArrow: $(".third-slide__l"),
       nextArrow: $(".third-slide__r"),
       responsive: [{
           breakpoint: 768,
           settings: {
             slidesToShow: 1,
             centerPadding: '0',
           }
         },

         {
           breakpoint: 992,
           settings: {
             slidesToShow: 3,
             centerPadding: '0',
           }
         },

         {
           breakpoint: 1200,
           settings: {
             slidesToShow: 4,
             centerPadding: '0',
           }
         },

       ]
     },
     // BREAKPOINT: 1600,
     // CLASSNAME: '',
   },

   LAST_SLIDER: {
     ELEMENT: $(".last-slider"),
     SETTINGS: {
       accessibility: true,
       arrows: true,
       dots: false,
       speed: 1500,
       variableWidth: true,
       slidesToShow: 3,
       centerMode: true,
       infinite: true,
       centerPadding: '200px',
       prevArrow: $(".last-slide__l"),
       nextArrow: $(".last-slide__r"),
       responsive: [{
           breakpoint: 576,
           settings: {
             slidesToShow: 1,
             edgeFriction: 0.5,
             centerPadding: '0',
             centerMode: false,
             variableWidth: true,
             arrows: false,
           }
         },

         {
           breakpoint: 768,
           settings: {
             slidesToShow: 1,
             edgeFriction: 0.5,
             arrows: false,
           }
         },
         {
           breakpoint: 1200,
           settings: {
             slidesToShow: 4,
             edgeFriction: 0.5,
             centerPadding: '0',
             variableWidth: false,
           }
         },

         {
           breakpoint: 1441,
           settings: {
             slidesToShow: 4,
             edgeFriction: 0.5,
             centerPadding: '0',
             variableWidth: false,
           }
         },


         {
           breakpoint: 1601,
           settings: {
             slidesToShow: 4,
             edgeFriction: 0.5,
             centerPadding: '0',
             variableWidth: false,
           }
         },

       ]
     },
     // BREAKPOINT: 1600,
     // CLASSNAME: '',
   },

   FAQ_SLIDER: {
     ELEMENT: $(".faq-slider"),
     SETTINGS: {
       accessibility: true,
       arrows: true,
       dots: false,
       speed: 1500,
       adaptiveHeight: true,
       focusOnSelect: true,
       variableWidth: true,
       slidesToShow: 3,
       infinite: true,
       centerMode: true,
       // centerPadding: '200px',
       // autoplay: true,
       // autoplaySpeed: 6000,
       prevArrow: $(".faq-slide__l"),
       nextArrow: $(".faq-slide__r"),
       responsive: [{
           breakpoint: 576,
           settings: {
             slidesToShow: 1,
             centerPadding: '0',
             centerMode: false,
             variableWidth: true,
             adaptiveHeight: false,
           }
         },

       ]
     },
     // BREAKPOINT: 1600,
     // CLASSNAME: '',
   },

   REASON_SLIDER: {
     ELEMENT: $(".reasons-sec__list"),
     SETTINGS: {
       accessibility: true,
       arrows: true,
       dots: false,
       speed: 800,
       focusOnSelect: true,
       variableWidth: true,
       slidesToShow: 3,
       infinite: true,
       centerMode: true,
       responsive: [{
           breakpoint: 576,
           settings: {
             slidesToShow: 1,
             centerPadding: '0',
             adaptiveHeight: true,
           }
         },

       ]
     },
     BREAKPOINT: 991,
     // CLASSNAME: '',
   },

   BIG_SLIDER: {
     ELEMENT: $(".big-slider"),
     SETTINGS: {
       accessibility: true,
       arrows: true,
       dots: false,
       speed: 1500,
       asNavFor: ".nav-slider",
       slidesToShow: 1,
       infinite: true,
       centerPadding: '23.5vw',
       centerMode: true,
       prevArrow: $(".big-slider__l"),
       nextArrow: $(".big-slider__r"),
       responsive: [{
           breakpoint: 768,
           settings: {
             slidesToShow: 1,
             centerPadding: '0',
           }
         },
         {
           breakpoint: 992,
           settings: {
             slidesToShow: 1,
             initialSlide: 2,
           }
         },

         {
           breakpoint: 1201,
           settings: {
             centerPadding: '15%',
           }
         },
         {
           breakpoint: 1441,
           settings: {
             centerPadding: '15%',
           }
         },

         {
           breakpoint: 1601,
           settings: {
             centerPadding: '15%',
           }
         },

       ]
     },
     // BREAKPOINT: 1600,
     // CLASSNAME: '',
   },

   NAV_SLIDER: {
     ELEMENT: $(".nav-slider"),
     SETTINGS: {
       accessibility: true,
       arrows: false,
       dots: false,
       speed: 1500,
       slidesToShow: 7,
       infinite: true,
       asNavFor: ".big-slider",
       centerMode: true,
       centerPadding: '0px',
       focusOnSelect: true,
     },
   },


 };

 function initialazeSlickSlider(slider) {
   const {
     BREAKPOINT,
     SETTINGS,
     ELEMENT
   } = slider;
   (document.documentElement.clientWidth <= BREAKPOINT ||
     BREAKPOINT === undefined) &&
   ELEMENT.slick(SETTINGS);
 }

 function toggleSlider(slider) {
   const {
     BREAKPOINT,
     ELEMENT,
     SETTINGS
   } = slider;
   document.documentElement.clientWidth > BREAKPOINT &&
     ELEMENT.hasClass("slick-initialized") &&
     ELEMENT.slick("unslick");
   document.documentElement.clientWidth <= BREAKPOINT &&
     !ELEMENT.hasClass("slick-initialized") &&
     ELEMENT.slick(SETTINGS);
 }

 function toggleExtraClass(slider) {
   const {
     BREAKPOINT,
     ELEMENT,
     CLASSNAME
   } = slider;
   document.documentElement.clientWidth > BREAKPOINT &&
     !ELEMENT.hasClass(CLASSNAME) &&
     ELEMENT.addClass(CLASSNAME);
   document.documentElement.clientWidth <= BREAKPOINT &&
     ELEMENT.hasClass(CLASSNAME) &&
     ELEMENT.removeClass(CLASSNAME);
 }

 initialazeSlickSlider(Sliders.MAIN_SLIDER);
 initialazeSlickSlider(Sliders.GALERY_SLIDER);
 initialazeSlickSlider(Sliders.BIG_SLIDER);
 initialazeSlickSlider(Sliders.LAST_SLIDER);
 initialazeSlickSlider(Sliders.NAV_SLIDER);
 initialazeSlickSlider(Sliders.FAQ_SLIDER);
 initialazeSlickSlider(Sliders.REASON_SLIDER);


 $('.program-box__item').hover(function () {
   $(this).addClass("active");
   $(".program-box__item").not(this).removeClass("active");
 });

 $(".template-tab__slider").slick({
   dots: false,
   autoplay: 1000,
   // prevArrow: false,
   // nextArrow: false
 });

 $(".tab").click(function (event) {
   $(".tab-content").removeClass("active");
   $(".tab").removeClass("active");
   $(".tab-image").removeClass("active");
   $(this).addClass("active");

   const tabId = $(this).data("tab");

   $($(`#tab${tabId}`)).addClass("active").find('.tab-image').toggleClass('active');

 });



 const items = document.querySelectorAll('.rent-box__inner');
 const images = document.querySelectorAll('.rent-box__image');

 images.forEach(function (image) {
   if (document.documentElement.clientWidth < 992) {
     image.classList.add('panel');
   } else {
     image.classList.remove('panel');
   }
 })

 items.forEach(function (item) {
   if (document.documentElement.clientWidth < 992) {
     item.classList.add('accordion');
   } else {
     item.classList.remove('accordion');
   }

 })


 const itemsFirst = document.querySelectorAll('.program-box__body');
 const imageFirst = document.querySelectorAll('.hidden-image');

 imageFirst.forEach(function (image) {
   if (document.documentElement.clientWidth < 992) {
     image.classList.add('panel');
   } else {
     image.classList.remove('panel');
   }
 })

 itemsFirst.forEach(function (item) {
   if (document.documentElement.clientWidth < 992) {
     item.classList.add('accordion');
   } else {
     item.classList.remove('accordion');
   }

 })


 // ----------------- Аккордион --------------------
 /**
  * Классы для аккордиона
  */
 const accordeon = {
   CLASS: 'accordion',
   CLASS_ACTIVE: 'active',
 }

 /**
  * acc - неизменная переменная для работы с аккордионом
  */
 const acc = document.querySelectorAll(`.${accordeon.CLASS}`);
 let openedAccordeon = null;

 /**
  * использует nextElementSibling для открытия или закрытия аккордиона
  */
 function closeAccordeon(acc) {
   acc.previousElementSibling.style.maxHeight = 0;
   acc.classList.remove(accordeon.CLASS_ACTIVE);
 }


 function openAccordeon(acc) {
   acc.previousElementSibling.style.maxHeight = `${acc.previousElementSibling.scrollHeight}px`;
   acc.classList.add(accordeon.CLASS_ACTIVE);
 }

 /**
  * Проверка на открытие аккордиона !nextElementSibling!
  */
 function isAccordeonOpen(acc) {
   acc.previousElementSibling && !acc.previousElementSibling.style.maxHeight
 }

 /**
  * Итерация, реализация переключения открытого аккордиона
  *
  */



 for (const accordeon of acc) {
   accordeon.addEventListener("click", function () {
     const currentAccordeon = this;

     openedAccordeon && closeAccordeon(openedAccordeon);

     if (isAccordeonOpen(currentAccordeon)) {
       closeAccordeon(currentAccordeon);
     } else {
       openAccordeon(currentAccordeon);
       openedAccordeon = currentAccordeon;
     }
   });
 };

 // --------------





 AOS.init();


 if (document.querySelector(".hard-box")) {
   var h = document.querySelector(".hard-box");
   var s = document.querySelector(".absolite-box__blur");

   if (document.documentElement.clientWidth < 992) {
     h.insertAdjacentElement("beforeend", s);
   }
 }

 $('.burger-menu').click(function () {
   $(this).toggleClass('active');
   $('.mobile-menu').toggleClass('active');
   $('body').toggleClass('fixed');
 });


 $('[data-modal=offer]').on('click', function () {
   $('.overlay, #offer-modal').fadeIn('slow');
 });

 $('[data-modal=characteristic]').on('click', function () {
   $('.overlay, #characteristic').fadeIn('slow');
 });

 $('.close-modal').on('click', function () {
   $('.overlay, .modal').fadeOut('slow');
 });

 jQuery(function ($) {
   $(document).mouseup(function (e) { // событие клика по веб-документу
     var div = $(".modal"); // тут указываем ID элемента
     if (!div.is(e.target) // если клик был не по нашему блоку
       &&
       div.has(e.target).length === 0) { // и не по его дочерним элементам
       $('.overlay, #offer-modal').fadeOut('slow');
     }
   });
   $(document).mouseup(function (e) { // событие клика по веб-документу
     var div = $(".modal"); // тут указываем ID элемента
     if (!div.is(e.target) // если клик был не по нашему блоку
       &&
       div.has(e.target).length === 0) { // и не по его дочерним элементам
       $('.overlay, #characteristic').fadeOut('slow');
     }
   });


   $(".header-nav").on("click", "a", function (event) {
     let dataTop = $(this).attr('data-top');
     var id = $(this).attr('href'),
       top = $(id).offset().top - dataTop;
     $('body,html').animate({
       scrollTop: top
     }, 1500);
   });


   $('.language-box__arrow').on('click', function () {
     $(this).closest('.language-box').toggleClass('active');
   });
   $('.language-list .item').on('click', function () {
     $(this).addClass('active').siblings().removeClass('active')
     $('.language-box').removeClass('active');
   })

  $(document).click(function (e) {
    if (!$(e.target).hasClass("active") &&
      $(e.target).parents(".language-box").length === 0) {
      $(".language-box").removeClass('active');
    }
  });



  var $status = $('.pagingInfo');
  var $slickElement = $('.team-main');

  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
  });

  $('.team-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.team-gallery',
  });

  $('.team-gallery').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    variableWidth: true,
    dots: false,
    asNavFor: '.team-main',
    arrows: false,
    focusOnSelect: true
  });
});




const makeNavLinksSmooth = ( ) => {
  const navLinks = document.querySelectorAll( '.nav-link' );

  for ( let n in navLinks ) {
    if ( navLinks.hasOwnProperty( n ) ) {
      navLinks[ n ].addEventListener( 'click', e => {
        e.preventDefault( );
        document.querySelector( navLinks[ n ].hash )
          .scrollIntoView( {
            behavior: "smooth"
          } );
      } );
    }
  }
}

const spyScrolling = ( ) => {
  const sections = document.querySelectorAll( '.hero-bg' );

  window.onscroll = ( ) => {
    const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;

    for ( let s in sections )
      if ( sections.hasOwnProperty( s ) && sections[ s ].offsetTop <= scrollPos ) {
        const id = sections[ s ].id;
        document.querySelector( '.active' ).classList.remove( 'active' );
        document.querySelector( `a[href*=${ id }]` ).parentNode.classList.add( 'active' );
      }
  }
}

makeNavLinksSmooth( );
spyScrolling( );
